import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classes from './DeliveryModeBadge.module.scss';

const MODES = ['online', 'mixed', 'offline', 'unknown'];

const LABEL_KEYS = {
  online: 'deliveryOnline',
  mixed: 'deliveryMixed',
  offline: 'deliveryOffline',
  unknown: 'deliveryUnknown',
};

export default function DeliveryModeBadge({ mode, size }) {
  const { t } = useTranslation('dashboard\\SyncMonitorView', {
    useSuspense: false,
  });

  const safe = MODES.includes(mode) ? mode : 'unknown';

  return (
    <span
      className={`${classes.badge} ${classes[safe]} ${classes[size] || ''}`}
      title={t(LABEL_KEYS[safe])}
    >
      {t(LABEL_KEYS[safe])}
    </span>
  );
}

DeliveryModeBadge.propTypes = {
  mode: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm']),
};

DeliveryModeBadge.defaultProps = {
  mode: 'unknown',
  size: 'sm',
};
